export const CONTAINER_FILENAME = 'index.html';
export const DEV_PORT = 9000;
export const STARDOG_SANDBOX_CONNECTION_NAME = 'Stardog Sandbox';
export const STARDOG_EXPRESS_CONNECTION_NAME = 'Stardog Express';
export const STARDOG_SANDBOX_ENDPOINT = 'https://sandbox.stardog.cloud:5820';
export const STARDOG_EXPRESS_ENDPOINT = 'https://express.stardog.cloud:5820';
export const STARDOG_EXPRESS_USERNAME = 'anonymous';
export const STARDOG_EXPRESS_PASSWORD = 'anonymous';
